module.exports = __webpack_public_path__ + "media/images/pc/specials/common/special_c_01-cc2d0f10f0398b2706b83a3044cbb5fa.png";